module.exports = __webpack_public_path__ + "img/cancel.8668dad5.png";